'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/~/react/react.js
// module id = 63
// module chunks = 168707334958949